import { useQuery } from '@tanstack/react-query';

import getScheduleDetail from 'Api/schedule/getScheduleDetail';

import getScheduleDetailPayload from './model/request/getScheduleDetailPayload';
import getScheduleDetailResponse from './model/response/getScheduleDetailResponse';

const useGetScheduleDetail = ({ enabled, payload }) => {
  return useQuery({
    queryKey: ['schedule-details', payload?.selectedEvent],
    queryFn: async () => {
      const queries = getScheduleDetailPayload(payload);

      const response = await getScheduleDetail({ queries });

      return getScheduleDetailResponse(response);
    },
    refetchOnWindowFocus: false,
    retry: 0,
    gcTime: 0,
    enabled,
  });
};

export default useGetScheduleDetail;
